import PageIndex from './src/index-emolm';
export default PageIndex;